<template>
  <div class="container w-100 h-100" ref="containerRef">
    <CardCTA
      @link-click="goToCardOverview"
      :link-text="t('VIRTUAL_CARD_CREATION_NOT_ALLOWED_VIEW.LINK')"
      :show-action-button="false"
    >
      <div class="w-100 h-100 text-center mt-5 mb-3">
        <span class="title-1">
          {{ t("VIRTUAL_CARD_CREATION_NOT_ALLOWED_VIEW.TITLE") }}
        </span>
        <br class="my-5" />
        <span
          class="title-2"
          v-html="t('VIRTUAL_CARD_CREATION_NOT_ALLOWED_VIEW.DESCRIPTION')"
        >
        </span>
      </div>
    </CardCTA>
  </div>
</template>

<script setup lang="ts">
import CardCTA from "@/apps/credit-line/components/CreditCard/CardCTA.vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { useRouter } from "vue-router";
import { useCreditLineSummary } from "@/apps/credit-line/hooks/useCreditLineSummary";
import { onMounted, ref } from "vue";
import { resizeComponentHelper } from "@/apps/credit-line/helpers/resizeComponent.helper";

const { t } = useI18n();
const router = useRouter();
const containerRef = ref();

const { summary } = useCreditLineSummary();

onMounted(() => {
  resizeComponentHelper(containerRef);
});

const goToCardOverview = () => {
  router.push({
    name: "CardOverview",
    query: {
      country: summary.value?.country,
      clientEligible: "false",
    },
  });
};
</script>

<style lang="scss" scoped>
.title-1 {
  margin-top: 30%;
  color: var(--Primary-Main-green, #007c3b);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter, sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 30.8px */
}

.title-2 {
  margin-bottom: 30%;
  color: var(--Typography-Text-2-ICON, #595a5a);
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 118%;
}
</style>
